<!-- Layout 3: Title Left, Description Right, Image Bottom -->
<div class="section-container layout-3-container" *ngIf="data?.title || data?.description || data?.buttonText">
  <div class="layout-3-content-row">
    <!-- Title on Left -->
    <div class="section-title-wrapper">
      <h2 class="section-title"
          *ngIf="data?.title"
          [style.color]="headingColor"
          [style.font-family]="headingFont"
          [ngStyle]="titleStyles || data?.titleStyle">{{ data?.title }}</h2>
    </div>
    
    <!-- Description and Button on Right -->
    <div class="section-content-wrapper">
      <p class="section-description"
         *ngIf="data?.description"
         [style.color]="paragraphColor"
         [style.font-family]="bodyFont">
        {{ data?.description }}
      </p>
      <button class="section-btn"
              *ngIf="data?.buttonText"
              [style.background-color]="primaryColor"
              [style.color]="headingColor"
              (click)="onButtonClick(data?.buttonLink, $event)">{{ data?.buttonText }}</button>
    </div>
  </div>
  
  <!-- Full-width Image at Bottom -->
  <div class="section-image-bottom" *ngIf="getImageSrc()">
    <img [src]="getImageSrc()" 
         [alt]="getImageAlt()"
         [style.object-fit]="getImageObjectFit()"
         class="detail-image">
  </div>
</div>
